import { render, staticRenderFns } from "./PremioT.vue?vue&type=template&id=12da5bf0"
import script from "./PremioT.vue?vue&type=script&lang=js"
export * from "./PremioT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports